import { useLocation } from 'react-router';
import { NavLink } from './NavLink';
import { MessageCounter } from './MessageCounter';
import { WalletButton } from '../WalletButton';
import { NavItem } from './types';

interface MobileMenuProps {
  isOpen: boolean;
  navItems: NavItem[];
  messageBalance: number;
  onClose: () => void;
}

export function MobileMenu({ isOpen, navItems, messageBalance, onClose }: MobileMenuProps) {
  const location = useLocation();

  if (!isOpen) return null;

  return (
    <div className="md:hidden absolute top-[73px] left-0 right-0 bg-black border-b border-white/[0.08] shadow-xl z-50">
      <div className="px-[24px] py-[16px] space-y-[8px]">
        {navItems.map((item) => (
          <NavLink
            key={item.path}
            path={item.path}
            label={item.label}
            icon={item.icon}
            isActive={location.pathname === item.path}
            onClick={onClose}
            mobile
          />
        ))}
        
        <MessageCounter balance={messageBalance} mobile />

        <div className="pt-[8px]">
          <WalletButton />
        </div>
      </div>
    </div>
  );
}
